import InfoButtonIcon from "../../assets/Icons/Universal/InfoIcon.svg";

const InfoButton = ({ description }) => {
  return (
    <button
      className="flex-row align-center justify-center transparentBtn"
      style={{ width: ".9rem", height: "0.9rem" }}
      title={description}
    >
      <img src={InfoButtonIcon} alt="info" className="w-full h-full" />
    </button>
  );
};

export default InfoButton;
